export default __webpack_public_path__ + "static/media/panier.d2f208b3.png";